module.exports = __webpack_public_path__ + "static/media/hardy-app-demo-home.9f7580be.mp4";